export const UPDATE_REMOTE_CONFIG_VALUES = 'UPDATE_REMOTE_CONFIG_VALUES';